module.exports = __webpack_public_path__ + "img/menu-hair-9.9dd0cb87.webp";